import { useTranslations } from 'next-intl';
import { boolean, object, string } from 'zod';

export const usePasswordResetSchema = object({
  email: string().email(),
});

export const useNewsletterEmailSchema = object({
  email: string().email({ message: 'vouchers.give.confirm.wrong_email.title' }),
});

export const useEmailSchema = () => {
  const t = useTranslations('common.error');
  return object({
    email: string().min(1, t('required')).email(t('string.email')),
  });
};

export const useBasketLoginAsGuestSchema = () => {
  const t = useTranslations('common.error');
  return object({
    email: string().min(1, t('required')).email(t('string.email')),
    consent: boolean(),
  });
};

export const useLoginSchema = () => {
  const t = useTranslations('common.error');
  return object({
    email: string().min(1, t('required')).email(t('string.email')),
    password: string().optional(),
  });
};
